module.exports = __webpack_public_path__ + "img/m2_jp.e3310f5.jpg";